import styled from 'styled-components'

import { breakpoints } from '@/config/layout'
import { ContentPagePaddingCSS } from '@/layout/components/content-page-layout/ContentPageLayout.styled'
import { VisibleScrollbarStyle } from '@/styles/scrollbar'

const StContainer = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  grid-template-areas:
    'content'
    'button';
`

const StContent = styled.div`
  ${VisibleScrollbarStyle}
  ${ContentPagePaddingCSS}
  grid-area: content;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  ${({ theme }) => `
    gap: ${theme.UI.SpacingPx.Space6};
  `}

  @media ${breakpoints.fromM} {
    padding: ${({ theme }) => theme.UI.SpacingPx.Space4}
      ${({ theme }) => theme.UI.SpacingPx.Space6} !important;
    margin: 0 auto;
    max-width: 600px;
    width: 100%;
    overflow-x: hidden;
  }
`

const StButtonContainer = styled.div`
  grid-area: button;
  box-shadow: 0px -1px 20px rgba(4, 24, 49, 0.07);

  padding: ${({ theme }) => theme.UI.SpacingPx.Space4}
    ${({ theme }) => theme.UI.SpacingPx.Space2};
  padding-bottom: calc(
    max(var(--safe-area-inset-bottom, 0px), 20px) +
      ${({ theme }) => theme.UI.Spacing.Space1}px
  );
  @media (${breakpoints.fromM}) {
    padding-bottom: calc(
      max(var(--safe-area-inset-bottom, 0px), 20px) +
        ${({ theme }) => theme.UI.Spacing.Space6}px
    );
  }

  @media ${breakpoints.fromM} {
    padding: ${({ theme }) => theme.UI.SpacingPx.Space4}
      ${({ theme }) => theme.UI.SpacingPx.Space6} !important;
    margin: 0 auto;
    max-width: 600px;
    width: 100%;
    overflow-x: hidden;
  }
  @media ${breakpoints.s} {
    box-shadow: none;
  }
`

const StCard = styled.div`
  ${({ theme }) => `
    background-color: ${theme.Components.Card.Fill};
    border: 1px solid ${theme.Components.Card.Border};
    border-radius: ${theme.UI.BorderRadius.Large}px;
    padding: ${theme.UI.SpacingPx.Space5};
  `}
`

const StHeaderWrapper = styled.div`
  ${ContentPagePaddingCSS}
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.Colors.Background.White};

  ${({ theme }) => `
    gap: ${theme.UI.SpacingPx.Space4};
  `}

  @media ${breakpoints.fromM} {
    padding: ${({ theme }) => theme.UI.SpacingPx.Space4}
      ${({ theme }) => theme.UI.SpacingPx.Space6} !important;
    padding-bottom: 0 !important;
    margin: 0 auto;
    max-width: 600px;
    width: 100%;
  }
`

export { StButtonContainer, StCard, StContainer, StContent, StHeaderWrapper }
